export default {"src":"/_next/static/media/SGMEDIA-LOGO.32010351.svg","height":283,"width":1366};